import React, {useContext, useEffect, useState} from "react";
import {Box, Button, Checkbox, CircularProgress, FormControlLabel, Stack, TextField, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {HugeiconsIcon} from "@hugeicons/react";
import {GoogleIcon} from "@hugeicons/core-free-icons";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {mapToUrl} from "../../../utils/functions";
import {AuthLayout} from "../components/AuthLayout";
import {enterToNext} from "../components/enterToNext";
import {AuthPasswordField} from "../components/AuthPasswordField";
import {a, fieldSx, linkSx, noticeSx, primaryButtonSx, secondaryButtonSx} from "../components/authStyles";

export const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const {onLogin} = useContext(SignInContext);
    const [showRegistrationMessage, setShowRegistrationMessage] = useState(false);

    useEffect(() => {
        const registrationSuccess = sessionStorage.getItem("registration_success");

        if (registrationSuccess === "true") {
            setShowRegistrationMessage(true);
            sessionStorage.removeItem("registration_success");
        }
    }, []);

    const loginHandle = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            await onLogin({username: email, password: password});
        } catch (err) {
            if (err.code === "PASSWORD_SETUP_REQUIRED") toast.info(err.message);
            else toast.error(err.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <AuthLayout
            kicker={"Sign in"}
            title={"Welcome back"}
            description={"Sign in to your OpenBrain workspace."}
            prompt={"New to OpenBrain?"}
            linkText={"Create an account"}
            linkTo={"/register"}
            banner={showRegistrationMessage && (
                <Box sx={noticeSx}>
                    <b>Check your email.</b> We sent you a verification link. Verify your account, then sign in.
                </Box>
            )}
        >
            <Stack component={"form"} onSubmit={loginHandle} onKeyDown={enterToNext} direction={"column"} gap={0.5} sx={{width: "100%"}}>
                <TextField
                    variant={"filled"}
                    required
                    autoFocus
                    fullWidth
                    label={"Email"}
                    type={"email"}
                    autoComplete={"username"}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder={"you@company.com"}
                    helperText={" "}
                    sx={fieldSx}
                />
                <AuthPasswordField
                    required
                    label={"Password"}
                    autoComplete={"current-password"}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder={"Your password"}
                    helperText={" "}
                />

                <Stack direction={"row"} gap={2} justifyContent={"space-between"} alignItems={"center"}
                       useFlexGap flexWrap={"wrap"} sx={{mb: 1}}>
                    <FormControlLabel
                        sx={{color: a.text, "& .MuiTypography-root": {fontSize: 13.5}}}
                        control={<Checkbox defaultChecked size={"small"} sx={{"&.Mui-checked": {color: a.accent}}}/>}
                        label="Remember me"
                    />
                    <Typography component={Link} to={"/forgot-password"} sx={linkSx}>Forgot password?</Typography>
                </Stack>

                <Button
                    fullWidth
                    type={"submit"}
                    disabled={loading || !email || !password}
                    sx={primaryButtonSx}
                    startIcon={loading ? <CircularProgress size={16} color={"inherit"}/> : null}
                >
                    Sign in
                </Button>

                <Typography sx={{textAlign: "center", color: a.muted, fontSize: 12.5, py: 1.5}}>or</Typography>

                <Button
                    component={"a"}
                    href={mapToUrl(`/api/auth/oauth2/google?redirect_uri=${encodeURIComponent(`${window.location.origin}/oauth2/redirect`)}`, process.env.REACT_APP_USERMANAGEMENT_GATEWAY)}
                    fullWidth
                    startIcon={<HugeiconsIcon icon={GoogleIcon} size={18}/>}
                    sx={secondaryButtonSx}
                >
                    Continue with Google
                </Button>
            </Stack>
        </AuthLayout>
    )
}
